import React from 'react';
import { Heart, Users } from 'lucide-react';
import img1 from '../../assets/renders/SITTINGSHELTE.jpeg';
import img2 from '../../assets/renders/CLUBHOUSE0.jpeg';

const LifestyleSection = () => {
  const lifestyles = [
    {
      type: "Independent Living",
      icon: Heart,
      description: "For active seniors who want freedom with access to services. Live the way you choose, Its your pleasant home, cook for yourself, take care of your well being, relax in the wellness centre, take a morning walk, indulge in the various recreation and community activities. Or just sip a cup of coffee along with your friends in the coffee bar. A cycling in the campus can still make you feel refreshed.",
      features: [
        "Freedom with services",
        "Cook for yourself",
        "Wellness centre access",
        "Community activities",
        "Coffee bar",
        "Cycling tracks"
      ],
      image: img1
    },
    {
      type: "Assisted Living",
      icon: Users,
      description: "You can be independent and live the way you want as long a you wish. However, Daily assistance with personal care and medication is on your door step. You can still relax on your sit out of your home reading your favourite books overlooking the sun kissed green parks.",
      features: [
        "Daily personal care assistance",
        "Medication management",
        "Maintain independence",
        "Private sit-out areas",
        "Beautiful park views",
        "24/7 support available"
      ],
      image: img2
    }
  ];

  return (
    <section className="pt-14 pb-10 sm:pt-20 bg-gradient-to-br from-red-50 to-orange-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-light text-gray-900 mb-8 tracking-tight leading-tight">
                Life at
                <span className="text-[var(--primarycolor)] font-normal"> Dignity</span>
              </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Choose the lifestyle that suits you best - complete independence or 
            assisted living with all the comforts of home.
          </p>
        </div>

        <div className="space-y-16">
          {lifestyles.map((lifestyle, index) => (
            <div key={index} className={`grid lg:grid-cols-2 gap-12 items-center ${index % 2 === 1 ? 'lg:grid-flow-dense' : ''}`}>
              {/* Image */}
              <div className={`${index % 2 === 1 ? 'lg:col-start-2' : ''}`}>
                <div className="aspect-[4/3] rounded-2xl overflow-hidden ">
                  <img 
                    src={lifestyle.image}
                    alt={lifestyle.type}
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              
              {/* Content */}
              <div className={`${index % 2 === 1 ? 'lg:col-start-1 lg:row-start-1' : ''}`}>
                <div className="flex items-center space-x-2 sm:space-x-4 mb-6">
                  <div className="w-10 sm:w-14 h-10 sm:h-14 bg-[var(--primarycolor)] rounded-xl flex items-center justify-center">
                    <lifestyle.icon className="w-5 sm:w-7 h-5 sm:h-7 text-white" />
                  </div>
                  <h3 className="text-2xl sm:text-3xl font-medium tracking-tight text-gray-900">
                    {lifestyle.type}
                  </h3>
                </div>
                
                <p className="text-gray-700 leading-relaxed mb-6">
                  {lifestyle.description}
                </p>
                
                <div className="grid sm:grid-cols-2 gap-4">
                  {lifestyle.features.map((feature, featureIndex) => (
                    <div key={featureIndex} className="flex items-center space-x-3">
                      <div className="w-2 h-2 bg-[var(--primarycolor)] rounded-full"></div>
                      <span className="text-gray-700">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LifestyleSection;